import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(pages)/(hotelDetail)/hotel/[country]/[city]/[hotelName]/(main)/components/rooms/hotelRooms.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(pages)/(hotelDetail)/hotel/[country]/[city]/[hotelName]/(main)/NewComponents/Dates.tsx");
